import { connect } from 'react-redux';

import type {
  ContainerProps,
  DispatchProps,
  OwnProps,
} from 'src/components/organisms/Personalisation/components/MultipleOptionSelection/MultipleOptionSelection';
import { MultipleOptionSelection } from 'src/components/organisms/Personalisation/components/MultipleOptionSelection/MultipleOptionSelection';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  selectNumberOfRequiredPersonalisations,
  selectOutstandingPersonalisations,
  selectSelectedOption,
  selectTrackedEvents,
} from 'src/redux/personalisation/selectors';
import { actions as personalisationActions } from 'src/redux/personalisation/slice';
import { selectPersonalisationOptions } from 'src/redux/product/selectors';

const mapStateToProps = (state: ReduxApplicationState, props: OwnProps): ContainerProps => ({
  currency: state.product.price.currency,
  error:
    Boolean(props.displayValidation) &&
    selectOutstandingPersonalisations(state).some((opt) => opt.id === props.id),
  options: selectPersonalisationOptions(state),
  selectedOption: selectSelectedOption(state, props.id),
  totalOutstandingSelections: selectOutstandingPersonalisations(state).length,
  totalRequiredPersonalisations: selectNumberOfRequiredPersonalisations(state),
  trackedEvents: selectTrackedEvents(state),
});

const mapDispatchToProps: DispatchProps = {
  deselectPersonalisation: personalisationActions.deselectPersonalisation,
  selectPersonalisation: personalisationActions.selectPersonalisation,
  trackInteraction: personalisationActions.trackInteraction,
  trackInteractionError: personalisationActions.trackInteractionError,
  trackProgressMilestone: personalisationActions.trackProgressMilestone,
};

export const MultipleOptionSelectionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MultipleOptionSelection);
